import type {
    AnchorProtocol,
    BackgroundProtocol,
    BaseBreakPointProtocol,
    CheckboxShapeEnum,
    CursorProtocol,
    IconDecorationProtocol,
    IndependentAction
} from '../../protocols'
import type { EventsProtocol } from '../../protocols/event'
import { BlockType } from '../Basic'
import { BaseBlock } from './BaseBlock'

export enum SwitchTypeEnum {
    SWITCH = 'SWITCH',
    CHECKBOX = 'CHECKBOX',
    CUSTOM = 'CUSTOM'
}

export interface OnOffBlockConfig extends BaseBreakPointProtocol, EventsProtocol, AnchorProtocol {
    checkedIcon?: {
        icon: IconDecorationProtocol
        color: BackgroundProtocol
    }
    unCheckedIcon?: {
        icon: IconDecorationProtocol
        color: BackgroundProtocol
    }
    defaultChecked?: boolean
    showType?: SwitchTypeEnum
    shape?: CheckboxShapeEnum
    // open: {
    //     action: IndependentAction
    // }
    // close: {
    //     action: IndependentAction
    // }

    cursor?: CursorProtocol
}

export abstract class OnOffBlockAbstract extends BaseBlock {
    type = BlockType.onOff

    abstract override config: OnOffBlockConfig
}
